
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import RegisterForm from "@/components/auth/RegisterForm";
import { useAuth } from "@/contexts/AuthContext";

const Signup = () => {
  const navigate = useNavigate();
  const { session, isLoading } = useAuth();

  useEffect(() => {
    // If already logged in, redirect to dashboard
    if (session && !isLoading) {
      navigate("/dashboard");
    }
  }, [session, isLoading, navigate]);

  if (isLoading) {
    return (
    <div className="min-h-screen bg-[#375062] flex flex-col justify-center py-12 sm:px-6 lg:px-8">
        <div className="text-center text-white">Loading...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#375062] flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="flex items-center justify-center gap-3 mb-2">
          <img src="/icon-mark.png" alt="Doyence" className="h-10 w-10" />
          <h1 className="text-3xl font-bold text-white">
            Doyence
          </h1>
        </div>
        <h2 className="text-center text-xl font-semibold text-white">
          Create a new account
        </h2>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <RegisterForm />
      </div>
    </div>
  );
};

export default Signup;
